<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">
    <span class="w-title">{{ adding?`新建${pageName}`:(editing ? `修改${pageName}` : `${pageName}详情`) }}</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="detail-btns">
        <v-btn color="info" flat @click="cancel">&lt; 返回{{ pageName }}列表</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!adding" color="error" flat outline @click="deleteThisItem">删除</v-btn>
        <v-btn v-if="detailing" color="info" flat class="btn-to-edit" @click="toEdit">去编辑 &gt;</v-btn>
      </div>
      <div class="form-panel">
        <div class="form-panel-head">发票信息</div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">公司:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-autocomplete
                  ref="form.companyId"
                  v-model="item.companyId"
                  no-data-text="无可用数据"
                  :items="companies"
                  :label="detailing?'':'请选择公司'"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">发票类型:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-select
                  ref="form.type"
                  v-model="item.type"
                  label="请选择发票类型"
                  :items="types"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-select>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="item.type==='专用发票'&&(editing||adding)?'required':''">地址电话:</label>
              </v-flex>
              <v-flex xs9 md10>
                <v-text-field
                  ref="form.addressPhone"
                  v-model="item.addressPhone"
                  :label="detailing?'':'请输入地址电话'"
                  outline
                  solo
                  :rules="item.type==='专用发票'?[rules.required]:[]"
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="item.type==='专用发票'&&(editing||adding)?'required':''">银行账号:</label>
              </v-flex>
              <v-flex xs9 md10>
                <v-text-field
                  ref="form.bankAccount"
                  v-model="item.bankAccount"
                  :label="detailing?'':'请输入银行账号'"
                  outline
                  solo
                  :rules="item.type==='专用发票'?[rules.required]:[]"
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">购方企业名称:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.toCompanyName"
                  v-model="item.toCompanyName"
                  :label="detailing?'':'请输入购方企业名称'"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">开票日期:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-menu
                  v-model="showStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      ref="form.receiptDate"
                      v-model="item.receiptDate"
                      label="开票日期"
                      readonly
                      :rules="[rules.required]"
                      outline
                      solo
                      :disabled="detailing"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.receiptDate"
                    locale="zh-cn"
                    @input="showStartDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="item.type==='专用发票'&&(editing||adding)?'required':''">购方税号:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.toCompanyTaxId"
                  v-model="item.toCompanyTaxId"
                  :label="detailing?'':'请输入购方税号'"
                  :rules="item.type==='专用发票'?[rules.required]:[]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>

              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">发票代码:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.code"
                  v-model="item.code"
                  :label="detailing?'':'请输入发票代码'"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>单据号:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.invoiceNumber"
                  v-model="item.invoiceNumber"
                  :label="detailing?'':'请输入单据号'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>商品编码版本号:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.itemCodeVersion"
                  v-model="item.itemCodeVersion"
                  :label="detailing?'':'请输入商品编码版本号'"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">发票号码:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.number"
                  v-model="item.number"
                  :label="detailing?'':'请输入发票号码'"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </div>

        <div class="form-panel-head">商品信息<span v-if="!detailing" style="font-size: 12px;color:#f00">（注:只有点击保存按钮后，商品的修改才生效）</span></div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-btn v-if="!detailing" color="info" @click="openItemDialog">新增商品</v-btn>
            <p></p>
            <v-spacer class="my-3"></v-spacer>
            <v-data-table
              ref="datatable"
              no-data-text="暂无数据"
              :headers="headers"
              :items="item.items"
              hide-actions
            >
              <template v-slot:items="props">
                <td>{{ props.item.itemName }}</td>
                <td>{{ props.item.itemModel }}</td>
                <td>{{ props.item.itemUnit }}</td>
                <td>{{ props.item.itemCount }}</td>
                <td class="money">{{ props.item.itemPrice }}</td>
                <td class="money">{{ props.item.totalPrice }}</td>
                <td>{{ props.item.taxRate }}</td>
                <td class="money">{{ props.item.taxPrice }}</td>
                <td>{{ props.item.taxCategoryCode }}</td>
                <td style="width:70px;display: flex;align-items: center;">
                  <v-tooltip v-if="!detailing" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        flat
                        icon
                        color="info"
                        v-on="on"
                        @click="currentItemIndex=props.index;editItem(props.item)">
                        <v-icon small>fa-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>编辑商品</span>
                  </v-tooltip>

                  <v-tooltip v-if="!detailing" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small flat icon color="error" v-on="on" @click="deleteItem(props.index)">
                        <v-icon small>fa-trash-alt</v-icon>
                      </v-btn>
                    </template>
                    <span>删除商品</span>
                  </v-tooltip>
                </td>
              </template>

              <template v-slot:footer>
                <td class="bold">统计:</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="bold money">{{ totalPriceSum }}</td>
                <td></td>
                <td class="bold money">{{ taxPriceSum }}</td>
                <td class="text-xs-right bold">价税合计:</td>
                <td class="bold money">
                  {{ totalSum }}
                </td>
              </template>
            </v-data-table>
          </v-container>
        </div>
      </div>
    </v-container>

    <!--弹出层-编辑产品-->
    <v-dialog v-model="showItemDialog" max-width="700px" persistent >
      <v-card>
        <v-card-title>商品信息</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-md class="xn-form pa-1">
            <v-layout wrap>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label class="required">商品名称:</label>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  ref="itemForm.itemName"
                  v-model="currentItem.itemName"
                  outline
                  solo
                  :rules="[rules.required]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label>规格:</label>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  ref="itemForm.itemModel"
                  v-model="currentItem.itemModel"
                  outline
                  solo
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label>税收分类编码:</label>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  ref="itemForm.taxCategoryCode"
                  v-model="currentItem.taxCategoryCode"
                  outline
                  solo
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label>单位:</label>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  ref="itemForm.itemUnit"
                  v-model="currentItem.itemUnit"
                  outline
                  solo
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label class="required">数量:</label>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  ref="itemForm.itemCount"
                  v-model="currentItem.itemCount"
                  outline
                  solo
                  :rules="[rules.required,rules.isNInteger]"
                  @keyup="calcTotalPrice"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label class="required">单价:</label>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  ref="itemForm.itemPrice"
                  v-model="currentItem.itemPrice"
                  outline
                  solo
                  suffix="元"
                  :rules="[rules.required,rules.isNumber]"
                  @keyup="calcTotalPrice"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label class="required">金额:</label>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  ref="itemForm.totalPrice"
                  v-model="currentItem.totalPrice"
                  outline
                  solo
                  suffix="元"
                  :rules="[rules.required,rules.isNumber]"
                  @keyup="calcTotalRate"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label class="required">税率:</label>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  ref="itemForm.taxRate"
                  v-model="currentItem.taxRate"
                  outline
                  solo
                  suffix="%"
                  :rules="[rules.required,rules.isInteger]"
                  @keyup="calcTotalRate"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2 class="d-flex mt-2 text-xs-right">
                <label class="required">税额:</label>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  ref="itemForm.taxPrice"
                  v-model="currentItem.taxPrice"
                  outline
                  solo
                  suffix="元"
                  :rules="[rules.required,rules.isNumber]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 offset-xs4>
                <v-btn flat outline style="margin-right: 10px !important;" @click="hideDialog">
                  取消
                </v-btn>
                <v-btn color="info" @click="saveItem">确定</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--弹出层-编辑产品-->

    <v-container fluid grid-list-md class="pa-0 my-5">
      <v-layout>
        <v-flex xs3 md4></v-flex>
        <v-flex xs6 md4 style="display:flex;justify-content: space-around">
          <v-btn outline @click="cancel">返回</v-btn>
          <v-tooltip v-if="!detailing" right>
            <template v-slot:activator="{ on }">
              <v-btn color="info" v-on="on" @click="save">保存</v-btn>
            </template>
            <span>保存发票及商品信息</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs3 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import axios from "../axios";
  import {mapState, mapActions} from "vuex";

  export default {
    components: {},
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
        companies: state => state.miniCompanies,
      }),
      id() {
        return this.$route.params.receiptId;
      },
      adding() {
        return !this.id;
      },
      editing() {
        return (!!this.id) && this.$route.name === "receipt-form-edit"
      },
      detailing() {
        return (!!this.id) && this.$route.name === "receipt-form-detail"
      },
      deleteIdObject() {
        let arr = [];
        arr.push(this.id);
        return {receiptIds: arr};
      },
      totalPriceSum() {
        if (this.item && this.item.items) {
          return this.item.items.map(item => item.totalPrice).reduce((a, b) => parseFloat(a) + parseFloat(b), 0).toFixed(2);
        } else {
          return 0;
        }
      },
      taxPriceSum() {
        if (this.item && this.item.items) {
          return this.item.items.map(item => item.taxPrice).reduce((a, b) => parseFloat(a) + parseFloat(b), 0).toFixed(2);
        } else {
          return 0;
        }
      },
      totalSum() {
        if (this.item && this.item.items) {
          let sum = parseFloat(this.totalPriceSum) + parseFloat(this.taxPriceSum);
          return sum.toFixed(2);
        } else {
          return 0;
        }
      }
    },
    data: () => ({
      urlName: 'receipts',
      pageName: '开票信息',
      rules: {
        required: value => !!value || "必填",
        isInteger: value => {
          const pattern = /^\d+$/;    //匹配正整数
          return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的数值";
        },
        isNInteger: value => {
          const pattern = /^-?[1-9]\d*$/;//匹配整数
          return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的数值";
        },
        isNumber: value => {
          const pattern = /^-?(([1-9][0-9]*)|(([0]\.\d{1,15}|[1-9][0-9]*\.\d{1,15})))$/;//保留15位小数  ///^\d+$/
          return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的数值";
        },
      },
      types: ["普通发票", "专用发票"],
      headers: [
        {text: '商品名称', value: 'itemName', sortable: false},
        {text: '规格', value: 'itemModel', sortable: false},
        {text: '单位', value: 'itemUnit', sortable: false},
        {text: '数量', value: 'itemCount', sortable: false},
        {text: '单价', value: 'itemPrice', sortable: false},
        {text: '金额', value: 'totalPrice', sortable: false},
        {text: '税率(%)', value: 'taxRate', sortable: false},
        {text: '税额', value: 'taxPrice', sortable: false},
        {text: '税收分类编码', value: 'taxCategoryCode', sortable: false},
        {text: '操作', value: '', sortable: false},
      ],
      hasErrors: false,
      item: {},
      currentItem: {},//当前编辑的商品信息
      currentItemIndex: -1,
      tempItem:{},//点击cancel，需要撤回修改的内容
      showStartDate: false,
      showItemDialog: false,
    }),
    methods: {
      ...mapActions(["setLoading"]),
      resetForm() {
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          )
            this.$refs["form." + f].resetValidation();
        });
      },
      validate() {
        this.hasErrors = false;
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      },
      validateItem() {
        this.hasErrors = false;
        Object.keys(this.currentItem).forEach(f => {
          if (
            this.$refs["itemForm." + f] !== null &&
            typeof this.$refs["itemForm." + f] !== "undefined"
          ) {
            if (!this.$refs["itemForm." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      },
      resetItemForm() {
        Object.keys(this.currentItem).forEach(f => {
          if (
            this.$refs["itemForm." + f] !== null &&
            typeof this.$refs["itemForm." + f] !== "undefined"
          )
            this.$refs["itemForm." + f].resetValidation();
        });
      },
      cancel() {
        this.$router.push({name: this.urlName});
      },
      toEdit() {
        this.$router.push("edit");
      },
      deleteThisItem() {
        this.$confirm("确定删除?").then(
          res => {
            if (res) {
              this.setLoading(true);
              axios
                .post(`/${this.urlName}/delete`, this.deleteIdObject)
                .then(() => {
                  this.setLoading(false);

                  this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                      this.cancel();
                    }
                  );
                })
                .catch(reason => {
                  this.$confirm(reason.response.data.message, {buttonFalseText: null});
                  this.setLoading(false);
                });
            }
          }
        );
      },
      calcTotalPrice() {
        //自动计算金额
        const pattern1 = /^-?[1-9]\d*$/;//数量可以为负
        if (!pattern1.test(this.currentItem.itemCount)) {
          return;
        }
        const pattern2 = /^-?(([1-9][0-9]*)|(([0]\.\d{1,15}|[1-9][0-9]*\.\d{1,15})))$/;
        if (!pattern2.test(this.currentItem.itemPrice)) {
          return;
        }
        let result = this.currentItem.itemCount * this.currentItem.itemPrice;
        this.currentItem.totalPrice = result.toFixed(2);

        this.calcTotalRate();
      },
      calcTotalRate() {
        //自动计算税率
        const pattern2 = /^-?(([1-9][0-9]*)|(([0]\.\d{1,15}|[1-9][0-9]*\.\d{1,15})))$/;
        if (!pattern2.test(this.currentItem.itemPrice)) {
          return;
        }
        let result2 = this.currentItem.totalPrice * this.currentItem.taxRate / 100;
        this.currentItem.taxPrice = result2.toFixed(2);
      },
      hideDialog(){
        this.showItemDialog = false;
        Object.assign(this.item.items[this.currentItemIndex],this.tempItem)
      },
      openItemDialog() {
        //打开商品窗口
        this.currentItem = {
          itemCount: null,//数量
          itemModel: null,//规格
          itemName: null,//商品名称
          itemPrice: null,//单价
          itemUnit: null,//单位
          taxCategoryCode: null,//税收分类编码
          taxPrice: null,//税额
          taxRate: null,//税率
          totalPrice: null//金额
        };
        this.showItemDialog = true;
        this.resetItemForm();
      },
      deleteItem(index) {
        //删除商品
        this.$confirm("确定删除?").then(
          res => {
            if (res) {
              this.item.items.splice(index, 1);
            }
          }
        );
      },
      editItem(item) {
        //编辑商品
        this.currentItem = item;
        Object.assign(this.tempItem,item);
        this.showItemDialog = true;
        this.resetItemForm();
      },
      saveItem() {
        //保存商品
        this.validateItem();
        if (!this.hasErrors) {
          if (this.currentItemIndex < 0) {
            this.item.items.push(this.currentItem);
          } else {
            this.item.items[this.currentItemIndex] = this.currentItem;
          }
          this.showItemDialog = false;
          this.currentItemIndex = -1;
        }
      },
      save() {
        this.validate();
        if (!this.hasErrors) {
          //去掉录入后，又不想录入 输入的空项
          for (let i in this.item) {
            if (this.item[i] === "") {
              delete this.item[i];
            }
          }
          if (this.editing) {
            //保存
            this.putEditHandler();
          } else {
            //添加
            this.postAddHandler();
          }
        }
      },
      postAddHandler() {
        this.setLoading(true);
        axios.post(`/${this.urlName}`, this.item)
          .then(() => {
            this.setLoading(false);

            this.$confirm("创建成功", {buttonFalseText: null}).then(() => {
              this.cancel();
            });
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      putEditHandler() {
        this.setLoading(true);
        axios.put(`/${this.urlName}/` + this.id, this.item)
          .then(() => {
            this.setLoading(false);

            this.$confirm("修改成功", {buttonFalseText: null}).then(() => {
              this.cancel();
            });
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      getDetailHandler() {
        this.setLoading(true);
        axios.get(`/${this.urlName}/` + this.id)
          .then(res => {
            this.item = res.data;
            this.setLoading(false);
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
    },
    created() {
      if (this.editing || this.detailing) {
        this.getDetailHandler();
      } else {
        this.item = {
          addressPhone: null,
          bankAccount: null,
          code: null,
          companyId: null,
          invoiceNumber: null,
          itemCodeVersion: null,
          number: null,
          receiptDate: null,
          toCompanyName: null,
          toCompanyTaxId: null,
          type: "普通发票",
          items: []
        }
      }
    }
  }
</script>

<style scoped>

</style>
